import Login from '../components/LogIn/Login'

const Auth = () => {
  return (
    <Login/>
  )
}

export default Auth